import { Box, Button, HStack, Menu, Text } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useRef } from "react"

const audienceStyles = {
  border: "1px solid",
  borderColor: "gray.400",
  color: "gray.600",
  borderRadius: "full",
  h: "26px",
  minW: 0,
  maxW: "175px",
  px: 2,
  py: 0,
  gap: 1,
  fontSize: "sm"
} as const

const ContentPublishAudience = ({
  name,
  shared,
  disabled,
  onRevert
}: {
  name: string
  shared: boolean
  disabled?: boolean
  onRevert?: () => void
}) => {
  const { tc, t } = useTranslate()
  const hovered = useRef(false)
  const label = (
    <>
      <Pathicon icon={shared ? "recur" : "group"} size="16px" />
      <Box as="span" truncate>
        {name}
      </Box>
    </>
  )

  return (
    <HStack
      gap={2}
      minW={0}
      flexShrink={0}
      flexWrap="nowrap"
      onMouseEnter={() => {
        hovered.current = true
      }}
      onMouseLeave={() => {
        hovered.current = false
      }}
    >
      <Text fontSize="sm" color="gray.500" whiteSpace="nowrap">
        {shared ? t("to") : t("in")}
      </Text>
      {onRevert ? (
        <Menu.Root
          lazyMount
          unmountOnExit
          onFocusOutside={(event) => {
            // Quill's delayed syntax highlighting can focus the editor behind
            // the menu. Preserve the interaction while the pointer is using it.
            if (hovered.current) event.preventDefault()
          }}
          // Keep the nested menu outside the card body's scroll clipping.
          positioning={{ placement: "bottom-end", strategy: "fixed" }}
        >
          <Menu.Trigger asChild>
            <Button
              {...audienceStyles}
              aria-label={tc("Publish audience")}
              variant="outline"
              colorPalette="gray"
              bg="transparent"
              disabled={disabled}
            >
              {label}
              <Pathicon icon="chevron-down" size="12px" />
            </Button>
          </Menu.Trigger>
          <Menu.Positioner>
            <Menu.Content minW="max-content">
              <Menu.Item
                value="source"
                onClick={onRevert}
                aria-label={tc("Revert to source version")}
                cursor="pointer"
                fontSize="sm"
                gap={1}
                px={2}
                py={1.5}
              >
                {tc("Revert to")} <Pathicon icon="recur" size="16px" />{" "}
                {t("source version")}
              </Menu.Item>
            </Menu.Content>
          </Menu.Positioner>
        </Menu.Root>
      ) : (
        <HStack {...audienceStyles}>{label}</HStack>
      )}
    </HStack>
  )
}

export default ContentPublishAudience
